import React, { useState } from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { OutlinedInputClassKey } from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import RenderTextField, { RenderTextFieldProps } from 'shared/forms/render-text-field';

import { useStyles } from './styles';

type Props<T> = Omit<RenderTextFieldProps<T>, 'customLabel'>;

export const BasePasswordInputField = <T,>({ InputProps, label, name, ...props }: Props<T>) => {
  const classes = useStyles();

  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
  };
  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <RenderTextField
      {...props}
      control={props.control}
      name={name}
      variant="standard"
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...InputProps,

        classes: {
          root: classes.basePasswordInput,
          focused: classes.basePasswordInputFocused,
          ...InputProps?.classes,
        } as Partial<ClassNameMap<OutlinedInputClassKey>>,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={togglePassword}
              onMouseDown={handleMouseDown}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      customLabel={
        <label htmlFor={name} className={classes.basePasswordInputFieldLabel}>
          {label}
        </label>
      }
    />
  );
};
